import SearchArea from "./SearchArea";
import { Fragment, useContext, useState } from "react";
import { ApprovedSearchContext } from "..";
import {
  Box,
  Collapse,
  Divider,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  useTheme,
} from "@mui/material";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import DetailsComponent from "./DetailsComponent";
// import useAuthentication from "@hooks/useAuthentication";
function PriorApprovalSecondSearch() {
  const theme = useTheme();
  const [selected, setSelected] = useState<number>(-1);
  const {
    searchResult,
    priorApprovalSearchParams,
    setPriorApprovalSearchParams,
  } = useContext(ApprovedSearchContext);

  const handleChangePage = (_: any, pageNo: number) => {
    setPriorApprovalSearchParams((prev) => ({
      ...prev,
      pageNo,
    }));
  };

  const handleChangeRowsPerPage = (e: any) => {
    setPriorApprovalSearchParams((prev) => ({
      ...prev,
      pageSize: parseInt(e.target.value, 10),
    }));
  };

  const handleOpen = (e: any) => {
    const index = parseInt(e.currentTarget.getAttribute("data-index") || "-1");
    if (index == selected) {
      setSelected(-1);
    } else {
      setSelected(index);
    }
  };

  // const{user}= useAuthentication();
  //  const regionValue= user?.region;
  //    const idHeading =
  //   regionValue === "QATAR_REGION"
  //     ? "Qatar ID"
  //     : "Emirates Id";
const idHeading = "Civil ID"
      const headings = [
  "Sl.no",
  idHeading,
  "Patient Id",
  "Full Name",
  "Payer Id",
  "Authorization Id",
  "Mobile No",
  "Member Id",
];

  return (
    <div className="px-3">
      <SearchArea />
      <Divider />
      <TableContainer className="h-[65dvh] max-h-[49dvh] overflow-y-auto relative">
        <Table
          size="small"
          aria-label="simple table"
          className={searchResult?.items?.length ? "w-full" : "h-full"}
        >
          <TableHead
            className="sticky top-0 z-50 border-b"
            sx={{
              backgroundColor: theme.palette.background.paper,
              opacity: 1,
            }}
          >
            <TableRow>
              {headings.map((heading, index) => (
                <TableCell key={index}>
                  <strong>{heading}</strong>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <CustomTableBody
            alert={"No data"}
            dataLoading={false}
            isData={Boolean(searchResult?.items?.length)}
            totalSpan={{
              row: priorApprovalSearchParams.pageSize,
              col: headings.length,
            }}
          >
            {searchResult?.items?.map((row, i) => (
              <Fragment key={`${i}${row?.patientDetails?.patientID}`}>
                <TableRow
                  hover
                  key={`${i}${row?.patientDetails?.patientID}`}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    cursor: "pointer",
                    backgroundColor:
                      i % 2 == 0
                        ? theme.palette.grey[100]
                        : theme.palette.background.paper,
                  }}
                  data-index={i}
                  onClick={handleOpen}
                >
                  <TableCell>
                    {priorApprovalSearchParams.pageSize *
                      priorApprovalSearchParams.pageNo +
                      i +
                      1}
                  </TableCell>
                  <TableCell>{row?.patientDetails?.emiratesID}</TableCell>
                  <TableCell>{row?.patientDetails?.patientID}</TableCell>
                  <TableCell>{row?.patientDetails?.fullName}</TableCell>
                  <TableCell>{row?.patientDetails?.payerID}</TableCell>
                  <TableCell>{row?.patientDetails?.authorizationId}</TableCell>
                  <TableCell>{row?.patientDetails?.mobileNo}</TableCell>
                  <TableCell>{row?.patientDetails?.memberID}</TableCell>
                </TableRow>
                <TableRow
                  sx={{
                    backgroundColor: i % 2 == 0 ? theme.palette.grey[100] : "",
                  }}
                >
                  <TableCell
                    sx={{
                      paddingBottom: 0,
                      paddingTop: 0,
                      backgroundColor:
                        1 % 2 == 0 ? theme.palette.grey[100] : "",
                    }}
                    colSpan={headings.length}
                  >
                    <Collapse in={i == selected} timeout="auto" unmountOnExit>
                      <Box sx={{ margin: 1 }}>
                        <DetailsComponent data={row?.activityDetails} />
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </Fragment>
            ))}
          </CustomTableBody>
        </Table>
      </TableContainer>
      <div>
        <TablePagination
          sx={{ bgcolor: theme.palette.background.paper }}
          rowsPerPageOptions={[5, 10, 15]}
          component="div"
          count={searchResult.totalCount || 0}
          rowsPerPage={priorApprovalSearchParams.pageSize || 0}
          page={priorApprovalSearchParams.pageNo || 0}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
}

export default PriorApprovalSecondSearch;

